import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=fc1c167c&scoped=true&"
import script from "./PrivacyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=fc1c167c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c167c",
  null
  
)

export default component.exports